import { useVillaReserveCancellationPolicies } from "@website/accommodation-ui/villa-reserve-cancellation-policies/index.hook";
import { villaReserveCancellationPolicyType } from "@website/accommodation-ui/villa-reserve-cancellation-policies/index.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Tabs } from "@website/ui/tabs";
import { FC } from "react";

export const VillaReserveCancellationPolicy: FC<
  villaReserveCancellationPolicyType
> = (properties) => {
  const {
    policiesData,
    openRulesModal,
    isRulesModalOpen,
    closeRulesModal,
    defaultTabPanel
  } = useVillaReserveCancellationPolicies(properties);

  return (
    <div>
      <p>مشاهده دقیق جزئیات لغو رزرو اقامتگاه</p>
      <Button
        color="secondary"
        className="!m-0 !p-0"
        variant="text"
        EndIcon={<MaterialIcon name="arrow_left" />}
        onClick={openRulesModal}
      >
        مشاهده بیشتر
      </Button>

      <Modal
        title="قوانین لغو رزرو"
        dialogClassName="flex flex-col justify-between lg:!w-full lg:!max-w-[448px] lg:!h-full lg:!max-h-[600px]"
        open={isRulesModalOpen}
        onClose={closeRulesModal}
        showCloseButton
        fullWidth
      >
        <div className="flex h-full flex-col justify-between overflow-auto">
          <div className="flex flex-col">
            <div className="w-full pt-4">
              {policiesData.tabs.length > 1 ? (
                <Tabs
                  color="secondary"
                  variant="underline"
                  size="fill"
                  tabs={policiesData.tabs}
                  className="!overflow-auto !px-0"
                  panelContainerClassName="!px-0 !py-2"
                />
              ) : (
                defaultTabPanel
              )}
            </div>
          </div>
        </div>

        <div className="hidden w-full justify-end bg-white py-2 lg:flex">
          <Button color="secondary" onClick={closeRulesModal}>
            متوجه شدم
          </Button>
        </div>
      </Modal>
    </div>
  );
};
